import React, { FC, memo } from 'react'
import SC from '../base/TableCol'
import { ITableColProps } from '../types'

const { Block } = SC

/** Колонка таблицы */
const TableCol: FC<ITableColProps> = (props) => {
  const { html, width, children, verticalAlign = 'middle', ...otherProps } = props

  return (
    <>
      {html ? (
        <Block
          dangerouslySetInnerHTML={{ __html: `${children}` }}
          {...otherProps}
          style={{ width, verticalAlign }}
        />
      ) : (
        <Block {...otherProps} style={{ width, verticalAlign }}>
          {children}
        </Block>
      )}
    </>
  )
}

export { TableCol }
export default memo(TableCol)
